<template>
  <footer
    class="db footer-margin relative bg-footer layout-footer z-footer pv4 pv5-ns"
    :class="{ 'il-footer-bg': isInsideLandsPage }"
  >
    <div class="container-fluid">
      <div class="db relative center mw8-5 footer-inner pv4">
        <!-- MOBILE -->
        <div class="db dn-l">
          <h3 class="f3 mv3 tl is-tablet-cond-bold is-white">
            We’ll send you the latest
          </h3>
          <div class="relative mb4 pb3">
            <signup-form></signup-form>
          </div>
          <div class="flex mt4 mb4 flex-row items-center justify-between mw20rem">
            <a
              class="dib relative pointer social-icon is-white-icon"
              v-for="social in footer_content.socials"
              :href="social.link"
              target="_blank"
              :title="social.title"
              :key="social.title"
            >
              <span class="icon" v-html="social.icon_svg"></span>
            </a>
          </div>
          <div class="relative mt2 mb4 tl">
            <div
              class="db relative w-100 mv3 footer-nav-parent-container"
              v-for="item in footer_content.footer_navigation"
              :key="item.title"
              v-if="item.is_published"
            >
              <footer-nav-item>
                <template slot="parent-nav-link">
                  <router-link
                    class="db is-white nav-link no-underline f4 is-tablet-cond-bold is-white"
                    :to="item.link"
                    :title="item.title"
                  >
                    {{ item.title }}
                  </router-link>
                </template>
                <template slot="sub-nav-links">
                  <router-link
                    v-for="sub_item in item.sub_nav_items"
                    class="db mv3 f4 is-white no-underline is-tablet-regular nav-link"
                    :to="sub_item.link"
                    v-if="sub_item.is_published"
                    :title="sub_item.title"
                    :key="sub_item.title"
                  >
                    {{ sub_item.title }}
                  </router-link>
                </template>
              </footer-nav-item>
            </div>
          </div>
          <div class="db relative mt3 w-100 mw21rem tl f5">
            <div class="flex flex-row items-center justify-between">
              <a
                class="db relative mr4 partner-icon pointer"
                v-for="(item, index) in footer_content.producer_partners"
                :class="item.css_class"
                :href="item.link"
                target="_blank"
                :title="item.title"
                :key="'producer-partner-' + index"
              >
                <simple-svg
                  class="icon"
                  :filepath="item.image"
                  :id="'partner-icon' + item.title"
                >
                </simple-svg>
              </a>
            </div>
          </div>
          <div class="db relative mt4 tl f5 is-white">
            &copy; Outside Lands 2021 |
            <router-link
              class="u link is-white pointer"
              to="/privacy-policy/"
              title="Privacy Policy"
              ><u>Privacy Policy</u></router-link
            >
            |
            <router-link
              class="u link is-white pointer"
              to="/terms-and-conditions/"
              title="Terms &amp; Conditions"
              ><u>Terms &amp; Conditions</u></router-link
            >
          </div>
        </div>
        <!-- DESKTOP -->
        <div class="dn db-l relative">
          <div class="row middle-sm pb4">
            <div class="col-sm-3">
              <div class="flex flex-row items-center justify-between tr">
                <a
                  class="dib relative pointer social-icon is-white-icon"
                  v-for="social in footer_content.socials"
                  :href="social.link"
                  target="_blank"
                  :key="social.title"
                  :title="social.title"
                >
                  <span class="icon" v-html="social.icon_svg"></span>
                </a>
              </div>
            </div>
          </div>
          <div class="row">
          <div class="relative row centering">
            <div class="col-sm-3  col-lg-4 relative re-size-form">
              <div class="flex relative flex-row items-center footer-sign-outer">
                <h3 class="w6 f4 mv3 tc ttn is-bureau-bold is-white mr1 new-header">
                  We’ll send you the latest
                </h3>
                <div class="relative w-100 mw-footer-signup ml2">
                  <signup-form></signup-form>
                </div>
              </div>
            </div>
 
            <div class="col spacing-col">
            <div class="col-sm-2 center margin-fix">
              <router-link
              class="db is-white ttn nav-link no-underline f4 is-tablet-bold"
                to="/tickets/">
              Tickets
              </router-link>
              <div class="relative mv2">
                <router-link
                class="db mv3 is-white no-underline f6 is-tablet-regular nav-link"
                to="/premium-experiences/">
                Premium Experiences
                </router-link>
              </div>
            </div>
            <div class="col-sm-2 center margin-fix">
              <router-link
              class="db is-white ttn nav-link no-underline f4 is-tablet-bold"
                to="/lineup/">
              Lineup
              </router-link>
              <div class="relative mv2">
                <router-link
                class="db mv3 is-white no-underline f6 is-tablet-regular nav-link"
                to="/past-lineups/">
                Past Lineups
                </router-link>
              </div>
            </div>
            </div>
            <div class="col spacing-col">
           <div class="col-sm-2 center margin-fix">
              <router-link
              class="db is-white ttn nav-link no-underline f4 is-tablet-bold"
                to="/lineup/">
              News
              </router-link>
              <div class="relative mv2">
                <router-link
                class="db mv3 is-white no-underline f6 is-tablet-regular nav-link"
                to="/past-lineups/">
                Most Recent
                </router-link>
              </div>
            </div>
            <div class="col-sm-2 center">
              <router-link
              class="db is-white ttn nav-link no-underline f4 is-tablet-bold"
                to="/contact/">
              Connect
              </router-link>
              <div class="relative mv2">
                <router-link
                class="db mv3 is-white no-underline f6 is-tablet-regular nav-link"
                to="/contact/">
                Contact Us
                </router-link>
                <router-link
                class="db mv3 is-white no-underline f6 is-tablet-regular nav-link"
                to="/press/">
                Press
                </router-link>
              </div>
            </div>

            </div>
            <div
              v-for="item in footer_content.footer_navigation"
              class="col-md-2 center"
              :class="{ dn: !item.is_published }"
              :key="item.title"
            >
              <router-link
                class="db is-white ttn nav-link no-underline f4 is-tablet-bold"
                :to="item.link"
                :title="item.title"
              >
                {{ item.title }}
              </router-link>
              <div class="relative mv2">
                <router-link
                  v-for="sub_item in item.sub_nav_items"
                  v-if="sub_item.is_published"
                  class="db mv3 is-white no-underline f6 is-tablet-regular nav-link"
                  :to="sub_item.link"
                  :key="sub_item.title"
                  :title="sub_item.title"
                >
                  {{ sub_item.title }}
                </router-link>
              </div>
            </div>
    
          </div>
          </div>
          <div class="relative w-100 pt4">
            <div class="db absolute left-0 abs-vert-center tl f5 is-white">
              &copy; Outside Lands 2021 |
              <router-link
                class="u link is-white pointer"
                to="/privacy-policy/"
                title="Privacy Policy"
                ><u>Privacy Policy</u></router-link
              >
              |
              <router-link
                class="u link is-white pointer"
                to="/terms-and-conditions/"
                title="Terms &amp; Conditions"
                ><u>Terms &amp; Conditions</u></router-link
              >
            </div>
            <div class="db absolute right-0 abs-vert-center w8" style="width: 400px">
              <div class="flex relative width-icons flex-row items-center justify-between">
                <a
                  class="dib relative center mv3 pl8 pointer partner-icon mw10rem"
                  v-for="item in footer_content.producer_partners"
                  :class="item.css_class"
                  :href="item.link"
                  target="_blank"
                  :title="item.title"
                  :key="item.title"
                >
                  <simple-svg
                    class="icon"
                    :filepath="item.image"
                    :id="'partner-icon' + item.title"
                  >
                  </simple-svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import SignupForm from "./signup-form.vue";
import FooterNavItem from "./footer-nav-item.vue";
export default {
  components: {
    SignupForm,
    FooterNavItem,
  },
  data() {
    return {
      //subNavMenuItemClicked: false,
      isInsideLandsPage: false,
    };
  },
  computed: {
    footer_content: function () {
      var footerContentData = this.$store.getters.filterPagesByName("footer.markdown");
      //console.log(footerContentData[0])
      return footerContentData[0];
    },
  },
  methods: {
    //
  },
  watch: {
    $route(to, from) {
      //console.log('route change', to);
      if (to.path === "/insidelands/") {
        this.isInsideLandsPage = true;
      } else {
        this.isInsideLandsPage = false;
      }
    },
  },
  created() {
    if (this.$route.path === "/insidelands/") {
      this.isInsideLandsPage = true;
    } else {
      this.isInsideLandsPage = false;
    }
  },
  updated() {
    /****************************
      isHomepage check
      ****************************/
    /*
      if (this.$route.path === "/") {
        this.isHomepage = true;
      }
      else {
        this.isHomepage = false;
      }
      */
  },
};
</script>
